/* ============================================
   No Lo Busques Más – Slideshow Custom Element
   ============================================ */
if (!customElements.get('nlbm-slideshow')) {
  class NlbmSlideshow extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.autoplayTimer = null;
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.isHovered = false;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      this.slides = this.querySelectorAll('[data-slide-index]');
      this.prevBtn = this.querySelector('[data-slide-prev]');
      this.nextBtn = this.querySelector('[data-slide-next]');
      this.dotsContainer = this.querySelector('.nlbm-slideshow__dots, .nlbm-testimonials__dots');

      if (!this.slides.length) return;

      this.buildDots();
      this.goToSlide(0);
      this.bindEvents();

      /* Auto-rotate unless in design mode */
      var isDesignMode = window.Shopify && window.Shopify.designMode;
      var autoplay = this.getAttribute('data-autoplay');

      if (autoplay === 'true' && !isDesignMode) {
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    get autoplaySpeed() {
      var speed = parseInt(this.getAttribute('data-autoplay-speed'), 10);
      if (isNaN(speed) || speed < 1) speed = 5;
      return speed * 1000;
    }

    buildDots() {
      if (!this.dotsContainer) return;
      this.dotsContainer.innerHTML = '';

      for (var i = 0; i < this.slides.length; i++) {
        var dot = document.createElement('button');
        dot.className = 'nlbm-slideshow__dot';
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', 'Ir a diapositiva ' + (i + 1));
        dot.dataset.index = i;
        this.dotsContainer.appendChild(dot);
      }
    }

    bindEvents() {
      var self = this;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          self.prev();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          self.next();
        });
      }

      if (this.dotsContainer) {
        this.dotsContainer.addEventListener('click', function (e) {
          var dot = e.target.closest('.nlbm-slideshow__dot');
          if (dot && dot.dataset.index !== undefined) {
            self.goToSlide(parseInt(dot.dataset.index, 10));
          }
        });
      }

      /* Touch / swipe support */
      this.addEventListener('touchstart', function (e) {
        self.touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', function (e) {
        self.touchEndX = e.changedTouches[0].screenX;
        self.handleSwipe();
      }, { passive: true });

      /* Keyboard navigation */
      this.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          self.prev();
        } else if (e.key === 'ArrowRight') {
          self.next();
        }
      });

      /* Pause on hover */
      this.addEventListener('mouseenter', function () {
        self.isHovered = true;
        self.stopAutoplay();
      });

      this.addEventListener('mouseleave', function () {
        self.isHovered = false;
        if (self.getAttribute('data-autoplay') === 'true') {
          self.startAutoplay();
        }
      });
    }

    handleSwipe() {
      var deltaX = this.touchEndX - this.touchStartX;
      if (Math.abs(deltaX) < 50) return;

      if (deltaX < 0) {
        this.next();
      } else {
        this.prev();
      }
    }

    goToSlide(index) {
      if (index < 0) index = this.slides.length - 1;
      if (index >= this.slides.length) index = 0;

      this.slides.forEach(function (slide, i) {
        slide.classList.toggle('nlbm-slideshow__slide--active', i === index);
      });

      /* Update dots */
      if (this.dotsContainer) {
        var dots = this.dotsContainer.querySelectorAll('.nlbm-slideshow__dot');
        dots.forEach(function (dot, i) {
          dot.classList.toggle('nlbm-slideshow__dot--active', i === index);
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      this.currentIndex = index;
      this.setAttribute('data-current-slide', index);
    }

    next() {
      this.goToSlide(this.currentIndex + 1);
      this.restartAutoplay();
    }

    prev() {
      this.goToSlide(this.currentIndex - 1);
      this.restartAutoplay();
    }

    startAutoplay() {
      if (this.prefersReducedMotion) return;
      this.stopAutoplay();

      var self = this;
      this.autoplayTimer = setInterval(function () {
        if (!self.isHovered) {
          self.goToSlide(self.currentIndex + 1);
        }
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    restartAutoplay() {
      if (this.getAttribute('data-autoplay') === 'true' && !this.isHovered) {
        this.startAutoplay();
      }
    }
  }

  customElements.define('nlbm-slideshow', NlbmSlideshow);
}
